<template>
  <div>
    <v-card>
      <v-card-title>
        <v-flex d-flex lg4 offset-lg4>
          <center><img src="archivos/logo.png" width="100%"/></center>
        </v-flex>
      </v-card-title>
    </v-card>
    <v-card>
      <v-card-title>
        <span class="headline">Colegio: {{ datos.colegio }}</span>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="datos.data"
          :pagination.sync="pagination"
          :total-items="totalRegistros"
          :loading="loading"
          :hide-actions="1 === 1"
          rows-per-page-text="Filas por página"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.fila[0] }}</td>
            <td>{{ props.item.fila[1] }}</td>
            <td>{{ props.item.fila[2] }}</td>
            <td class="">{{ props.item.fila[3] }}</td>
            <td class="">{{ props.item.fila[4] }}</td>
            <td class="">{{ props.item.fila[5] }}</td>
            <td class="">{{ props.item.fila[6] }}</td>
            <td class="">{{ props.item.fila[7] }}</td>
            <td class="">{{ props.item.fila[8] }}</td>
            <td class="">{{ props.item.fila[9] }}</td>
            <td class="">{{ props.item.fila[10] }}</td>
          </template>
          <template slot="no-data">
            <p>No hay datos</p>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: () => ({
    loading: false,
    datos: [],
    registro: {},
    grado: '',
    asesor: {},
    headers: [
      { text: '#', value: 0 },
      { text: 'Código', value: 1 },
      { text: 'Alumno', value: 2 },
      { text: 'Grado', value: 3 },
      { text: 'Buenas', value: 4 },
      { text: 'Malas', value: 5 },
      { text: 'Vacías', value: 6 },
      { text: 'Puntos', value: 7 },
      { text: 'Nota', value: 8 },
      { text: 'Ord. mérito', value: 9 },
      { text: 'Mérito', value: 10 }
    ],
    totalRegistros: 0,
    pagination: {}
  }),
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.cierreFecha' (val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}resultado.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
            this.$forceUpdate()
          }
        })
    },
    imprimirInscritos () {
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.API}resultado.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Resultado.vue